<script lang="ts" setup>
import api from "@/modules/api";
import { useTranslate } from "@/stores/translate";
import { computed, ref } from "vue";

const props = defineProps<{
  translateTarget: HTMLElement | string | null;
  postProcess?: (text: string) => string;
  result: string;
  btnClass?: string;
  translateBtnClass?: string;
}>();

const emit = defineEmits<{
  (e: "update:result", txt: string): void;
}>();

// States
const translateStore = useTranslate();
const loading = ref(false);
const inputTxt = computed(() => {
  if (typeof props.translateTarget === "string") {
    return props.translateTarget;
  }
  if (props.translateTarget) {
    return props.translateTarget.innerText;
  }
  return "";
});
const translate = async () => {
  loading.value = true;
  try {
    const { data } = await api.translate({
      text: inputTxt.value,
      targetLanguage: translateStore.targetLang,
    });
    emit("update:result", data.text);
  } finally {
    loading.value = false;
  }
};
</script>
<template>
  <button
    :class="[btnClass, translateBtnClass]"
    :disabled="loading"
    class="btn btn-square"
    @click="translate"
  >
    <i v-if="!loading" class="iconify mdi--language" />
    <span v-else class="loading loading-sm loading-infinity" />
  </button>
</template>
